import React from 'react';
import { Tooltip } from 'antd';
import { Stepper } from '@gerdau/hefesto-mais-web';
import theme from '../../../assets/styles/theme/theme';
import { Container } from './styles';

interface QuantityInputProps {
  value: string;
  onChange(value: string): void;
  onIncreaseClick(): void;
  onDecreaseClick(): void;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  disabledInput?: boolean;
  errorMessage?: string;
  placeholder?: string;
  minValue?: number;
  visible?: boolean;
}

const IncreaseDecreaseInputButton: React.FC<QuantityInputProps> = ({
  value,
  onChange,
  onIncreaseClick,
  onDecreaseClick,
  disabled = false,
  readOnly = false,
  disabledInput,
  errorMessage,
  minValue = 0,
  visible,
  label
}) => {
  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const validateRegex = new RegExp(/^\d*(\.\d{0,3})?$/); // regex pra aceitar somente números e 3 casas decimais

    if (e.type !== 'click') {
      onChange(newValue);
      return;
    }

    if (validateRegex.test(newValue)) {
      const oldValue = value.includes('x')
        ? value.replace(/[^\d]/g, '')
        : value;

      if (Number(newValue) > Number(oldValue)) {
        onIncreaseClick();
        return;
      }
      if (Number(oldValue) > minValue) {
        onDecreaseClick();
        return;
      }
    }
  };

  return (
    <Tooltip
      overlayClassName="shop-cart-input-tooltip"
      placement="top"
      title={errorMessage}
      trigger={['hover', 'click']}
      color={theme.colors.red}
      visible={visible}
      getPopupContainer={(triggernode) => triggernode}
    >
      <Container error={errorMessage !== '' ? true : false}>
        <Stepper
          label={label ?? ''}
          name={'increaseDrecreaseInput'}
          disabled={disabled || disabledInput}
          readOnly={readOnly}
          value={value.includes('x') ? value.replace(/[^\d]/g, '') : value}
          onChange={(e) => onChangeInput(e)}
        />
      </Container>
    </Tooltip>
  );
};

export default IncreaseDecreaseInputButton;
